import { IFeatureState } from './types';

export const FeatureOff = ({ children, enabled }: IFeatureState) => <>{!enabled && children}</>;
